module.exports = __webpack_public_path__ + "media/images/emblems/Laax_wappen-7b61669e72695ac9d8e9419939ce4b08.svg";